import { ThemeState } from '@/store/modules/theme'
import { Vue, Component, Watch } from 'vue-property-decorator'

enum MessageType {
  VIEW = 'view',
  THEME = 'theme',
}

// this is to listen and send messages between admin and app
@Component
export class BridgeHandler extends Vue {
  public $bridgeMessageTheme (state: ThemeState) {
    this.$bridgeMessage(MessageType.THEME, { state })
  }

  public $bridgeMessageView (view: string) {
    this.$bridgeMessage(MessageType.VIEW, { view })
  }

  private $bridgeMessage (type: MessageType, data: Record<string, unknown>) {
    window.postMessage({ admin: true, type, ...data }, window.origin)
  }

  public $bridgeListenMessages () {
    window.parent.addEventListener('message', this.$bridgeHandleMessage)
  }

  private $bridgeHandleMessage (event: MessageEvent): void {
    if (!event.data.admin) return

    switch (event.data.type) {
      case MessageType.VIEW: {
        this.$router.push(`/${event.data.view}`)

        break
      }
      case MessageType.THEME: {
        this.$store.commit('SET_THEME_IS_DARK', event.data.state.isDark)
        this.$store.commit('SET_THEME_PRIMARY_COLOR', event.data.state.primaryColor)
        this.$store.commit('SET_THEME_FONT', event.data.state.font)
        this.$store.commit('SET_THEME_LOGO_IMAGE_URL', event.data.state.logoImageUrl)
        this.$store.commit('SET_THEME_BACKGROUND_IMAGE_URL', event.data.state.backgroundImageUrl)
        this.$store.commit('SET_THEME_HEADER_IMAGE_URL', event.data.state.headerImageUrl)
        this.$store.commit('SET_THEME_NEWSLETTER_IMAGE_URL', event.data.state.newsletterImageUrl)

        break
      }
      default: {
        break
      }
    }
  }
}
